var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jr-component"},[_c('span',_vm._b({staticClass:"jr-labelwhere",style:('width: ' + _vm.width + ';'),attrs:{"id":_vm.id,"title":_vm.headValue + _vm.whereValue}},'span',_vm.$attrs,false),[_vm._v(_vm._s(_vm.headValue + _vm.whereValue))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b6410c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/componentsjr/JrLabelwhere.vue
// module id = null
// module chunks = 